module.exports = __webpack_public_path__ + "static/media/compare.d82efd04.svg";